import React from 'react';
import { observer } from 'mobx-react-lite';
import globalUserProfile from '../../../../stores/global-user-profile';
import { StudentProfile } from '../../../../api/types/settings/settings-all';
import { ProgramWithStudentStatus } from '../../../../api/types/students/programs/student-program-with-status';
import { getProgramStudentStatusDisplayText } from '../../../../api/types/programs/students/program-student-status';

export const MyPrograms = observer(() => {
  // Check if user profile exists and is a student
  if (!globalUserProfile.userProfile?.profile) {
    return <div>Loading user profile...</div>;
  }

  const studentProfile = globalUserProfile.userProfile
    .profile as StudentProfile;
  const programs: ProgramWithStudentStatus[] = studentProfile.programs;

  if (!programs || programs.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>התוכניות שלי</h2>
        <p>לא נמצאו תוכניות רשומות</p>
      </div>
    );
  }

  return (
    <div>
      <h2>התוכניות שלי</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {programs.map((program) => (
          <div
            key={program.id}
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '16px',
              backgroundColor: '#f9f9f9',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <h3
                  style={{
                    margin: '0 0 8px 0',
                    fontSize: '18px',
                    fontWeight: 'bold',
                  }}
                >
                  {program.programName}
                </h3>
                <p style={{ margin: '4px 0', color: '#666' }}>
                  <strong>שנות לימוד:</strong> {program.years}
                </p>
                <p style={{ margin: '4px 0', color: '#666' }}>
                  <strong>שנת התחלה:</strong> {program.programStartYear}
                </p>
                <p style={{ margin: '4px 0', color: '#666' }}>
                  <strong>מספר סידורי שנתי:</strong>{' '}
                  {program.annualSerialNumber}
                </p>
              </div>
              <div style={{ textAlign: 'left' }}>
                <span
                  style={{
                    padding: '4px 12px',
                    borderRadius: '16px',
                    backgroundColor: getStatusColor(
                      program.studentStatus.status,
                    ),
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: 'bold',
                  }}
                >
                  {getProgramStudentStatusDisplayText(
                    program.studentStatus.status,
                  )}
                </span>
              </div>
            </div>

            {/* Display important dates if they exist */}
            <div style={{ marginTop: '12px', fontSize: '14px', color: '#555' }}>
              {program.studentStatus.registrationDate && (
                <p style={{ margin: '2px 0' }}>
                  <strong>תאריך רישום:</strong>{' '}
                  {new Date(
                    program.studentStatus.registrationDate,
                  ).toLocaleDateString('he-IL')}
                </p>
              )}
              {program.studentStatus.studyingStartDate && (
                <p style={{ margin: '2px 0' }}>
                  <strong>תאריך תחילת לימודים:</strong>{' '}
                  {new Date(
                    program.studentStatus.studyingStartDate,
                  ).toLocaleDateString('he-IL')}
                </p>
              )}
              {program.studentStatus.completionDate && (
                <p style={{ margin: '2px 0' }}>
                  <strong>תאריך סיום:</strong>{' '}
                  {new Date(
                    program.studentStatus.completionDate,
                  ).toLocaleDateString('he-IL')}
                </p>
              )}
              {program.studentStatus.graduationDate && (
                <p style={{ margin: '2px 0' }}>
                  <strong>תאריך סיום הלימודים:</strong>{' '}
                  {new Date(
                    program.studentStatus.graduationDate,
                  ).toLocaleDateString('he-IL')}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

// Helper function to get status color
const getStatusColor = (status: string): string => {
  switch (status) {
    case 'STUDYING':
      return '#4CAF50'; // Green
    case 'REGISTERED':
      return '#2196F3'; // Blue
    case 'COMPLETED':
      return '#9C27B0'; // Purple
    case 'GRADUATED':
      return '#FF9800'; // Orange
    case 'CANCELLED':
    case 'LEFT':
      return '#F44336'; // Red
    default:
      return '#757575'; // Grey
  }
};
